import React, { useState } from "react";
import { Button, Spin } from "antd";
import { Modal } from "antd";
import styled from '@emotion/styled';

const StyledModal = styled(Modal)`
  .ant-modal-content {
    box-sizing: border-box;
    padding: 20px 10px 20px 10px;
  }

  .ant-modal-header {
    border-bottom: 0;
  }

  .ant-modal-title {
    font-weight: 900;
  }

  .ant-modal-footer {
    border-top: 0;
  }

  .ant-modal-body {
    padding: 20px;
  }
`;

const StyledSuccessModal = styled(Modal)`
  .ant-modal-content {
    box-sizing: border-box;
    padding: 20px 10px 20px 10px;
  }

  .ant-modal-header {
    border-bottom: 0;
  }

  .ant-modal-title {
    font-weight: 900;
  }
    
  .ant-modal-footer {
    border-top: 0;
  }

  .ant-modal-body {
    padding: 20px;
  }
`;

export const FreezeDealerForm = ({ props, setProps }) => {
  const [successVisible, setSuccessVisible] = useState(false);
  const [isActive, setIsActive] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const afterSubmit = () => {
    setSuccessVisible(true);
    setProps({ visible: false });
  };

  const onSubmit = (_, closeModal = true) => {
    const codDistribuidor = props.dataInfo.codigoDistribuidor;
    setIsActive(props.isActive);
    setLoading(true);

    return props
      .submit({ variables: {codDistribuidor} })
      .then(() => {
        setLoading(false);
        if (closeModal) afterSubmit();
      })
      .catch(() => {
        setLoading(false);
      });
  };
  
  const handleSuccessOk = () => {
    setSuccessVisible(false);
  }

  return (
    <>
      <StyledModal
        centered
        style={{
          // borderLeft: "20px solid #ffffff",
          // borderRight: "5px solid #ffffff",
          // borderImage: "linear-gradient(to bottom, #008200 0%, #03d503 100%) 1",
        }}
        headerStyle={{ borderBottom: 0 }}
        bodyStyle={{ padding: 0, borderTop: 0, borderBottom: 0 }}
        footerStyle={{ borderTop: 0 }}
        closable={false}
        // title={props.title}
        title={
          <div style={{ textAlign: "center" }}>
            {props.isActive ?
              <p>¿Está seguro de que desea congelar al distribuidor?</p>:
              <p>¿Está seguro de que desea descongelar al distribuidor?</p>}
          </div>
        }
        visible={props.visible}
        width={500}
        footer={[
          <Button
            key="cancel"
            disabled={loading}
            onClick={() => {
              setProps({
                title: props.title,
                subtitle: props.subtitle,
                okText: props.okText,
                visible: false,
              });
            }}
          >
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={onSubmit}
            loading={loading}
            disabled={loading}
          >
            {loading ? (isActive? 'Congelando...' : 'Descongelando...') : props.okText}
          </Button>,
        ].filter((btn) => btn)}
      >
        {
          props.isActive ? (
            <div style={{ textAlign: "left", padding: '20px 25px 10px 25px' }}>
              <p>
                Por razones de seguridad, esta acción únicamente eliminará los datos de este distribuidor en la aplicación.<br/>

                Para que vuelvan a estar disponibles, deberá procederse a su descongelación.
              </p>
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: '20px 20px 10px 20px' }}>
              <p>
                Esta acción habilitará al distribuidor a usar CLAVE.<br />

                Recuerde que es obligatoria la transmisión de información desde el ERP del distribuidor para hacer un uso de CLAVE completo.
              </p>
            </div>
          )
        }
      </StyledModal>
      <StyledSuccessModal
        centered
        closable={false}
        width={300}
        title=""
        visible={successVisible}
        onOk={handleSuccessOk}
        footer={[
          <div style={{ textAlign: 'center' }}>
            <Button
              key="submit"
              type="primary"
              onClick={handleSuccessOk}
            >
              Aceptar
            </Button>
          </div>
        ]}
      >
        <div style={{ textAlign: "center"}}>
          <p>
            <br />
            <br />
            {isActive ?
              "El distribuidor ha sido congelado" :
              "El distribuidor ha sido descongelado"
            }
          </p>
        </div>
      </StyledSuccessModal>
      {loading && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Spin size="large" />
        </div>
      )}
    </>
  );
};
 